export class MessageBoxState {
  static readonly QuestionnaireAccessRestricted = new MessageBoxState(
    'QuestionnaireAccessRestricted',
    'fa-exclamation-circle launch-error-icon',
    'launch-error-text',
  );
  static readonly PANotRequired = new MessageBoxState(
    'PANotRequired',
    'fa-check-circle green',
    'green',
  );
  static readonly Logout = new MessageBoxState(
    'Logout',
    'fa-sign-out',
    'logout-title',
  );
  static readonly ClaimSubmitted = new MessageBoxState(
    'ClaimSubmitted',
    'fa-check-circle green',
    'green',
  );
  static readonly CdexSubmitted = new MessageBoxState(
    'CdexSubmitted',
    'fa-check-circle green',
    'green',
  );
  static readonly PAConditional = new MessageBoxState(
    'PAConditional',
    'fa-exclamation-circle launch-error-icon',
    'launch-error-text',
  );

  key: string;
  iconClass: string;
  titleClass: string;

  constructor(key: string, iconClass: string, titleClass = '') {
    this.key = key;
    this.iconClass = iconClass;
    this.titleClass = titleClass;
  }
}
